var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloudService(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19_1909)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.601 21.5625C11.2701 21.5625 11.8125 21.0588 11.8125 20.4375C11.8125 19.8162 11.2701 19.3125 10.601 19.3125H2.52404C1.85495 19.3125 1.3125 19.8162 1.3125 20.4375C1.3125 21.0588 1.85495 21.5625 2.52404 21.5625H10.601Z",
    fill: "#A71E23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.601 15.5625C11.2701 15.5625 11.8125 15.0588 11.8125 14.4375C11.8125 13.8162 11.2701 13.3125 10.601 13.3125H2.52404C1.85495 13.3125 1.3125 13.8162 1.3125 14.4375C1.3125 15.0588 1.85495 15.5625 2.52404 15.5625H10.601Z",
    fill: "#ED1F34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6875 2.4375C22.6875 3.0588 22.1558 3.5625 21.5 3.5625H2.5C1.84418 3.5625 1.3125 3.0588 1.3125 2.4375C1.3125 1.8162 1.84418 1.3125 2.5 1.3125H21.5C22.1558 1.3125 22.6875 1.8162 22.6875 2.4375Z",
    fill: "#EF4E23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6875 8.4375C22.6875 9.0588 22.1558 9.5625 21.5 9.5625H2.5C1.84418 9.5625 1.3125 9.0588 1.3125 8.4375C1.3125 7.8162 1.84418 7.3125 2.5 7.3125H21.5C22.1558 7.3125 22.6875 7.8162 22.6875 8.4375Z",
    fill: "#D73926"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9715 15.3227C16.6924 15.3227 15.6625 16.3463 15.6625 17.6004C15.6625 17.8153 15.6926 18.0229 15.7487 18.2195C15.98 18.2862 16.1965 18.3873 16.3921 18.5167C16.5528 18.623 16.5968 18.8394 16.4906 19.0001C16.3843 19.1608 16.1678 19.2049 16.0072 19.0985C15.83 18.9814 15.6287 18.8973 15.412 18.8553C15.3088 18.8353 15.2019 18.8247 15.0922 18.8247C14.18 18.8247 13.4477 19.5544 13.4477 20.4458C13.4477 21.3372 14.18 22.0669 15.0922 22.0669H19.7433C21.0225 22.0669 22.0523 21.0432 22.0523 19.7891C22.0523 18.7953 21.4061 17.9463 20.5 17.6365C20.2634 17.5556 20.009 17.5115 19.7433 17.5115C19.4724 17.5115 19.213 17.5574 18.9725 17.6414C18.7906 17.7049 18.5916 17.609 18.5281 17.4271C18.4646 17.2452 18.5605 17.0463 18.7424 16.9827C19.056 16.8732 19.3931 16.8138 19.7433 16.8138C19.8808 16.8138 20.0162 16.8229 20.1489 16.8407C19.8323 15.9582 18.9789 15.3227 17.9715 15.3227ZM20.9274 17.0535C20.6674 15.6686 19.4404 14.625 17.9715 14.625C16.3149 14.625 14.9648 15.9532 14.9648 17.6004C14.9648 17.7804 14.981 17.9569 15.0121 18.1284C13.7592 18.1702 12.75 19.188 12.75 20.4458C12.75 21.7303 13.8025 22.7645 15.0922 22.7645H19.7433C21.4 22.7645 22.75 21.4363 22.75 19.7891C22.75 18.5596 21.9971 17.5076 20.9274 17.0535Z",
    fill: "#00AFD2"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19_1909"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudService);
export default __webpack_public_path__ + "static/media/cloud-service.05263ead2018150a1fe61e6fea460b94.svg";
export { ForwardRef as ReactComponent };